import { defineStore } from 'pinia'

export const useScreenStore = defineStore("screen", {
  state: () => ({
    // 0: 移动端  1：ipad端  2：pc端
    screen: 2,
  }),
  actions: {
    updateScreen(screen) {
      this.screen = screen
    },
  },
})